import { InputTypeEnum } from "../enums/inputTypeEnum";
import { SharePointInputTypes, SharePointMetadataBooleans, SharePointFormatTypes } from "../../config/sharepointConstants";

export class InputTypeSharePointClassifier {
    constructor() { }
    getInputType(metadata: any): InputTypeEnum {
        switch (true) {
            case metadata.Type === SharePointInputTypes.text: {
                return InputTypeEnum.Text;
            }
            case metadata.Type === SharePointInputTypes.number && (!metadata.Percentage || metadata.Percentage === SharePointMetadataBooleans.false): {
                return InputTypeEnum.Number;
            }
            case metadata.Type === SharePointInputTypes.number && metadata.Percentage === SharePointMetadataBooleans.true: {
                return InputTypeEnum.Percentage;
            }
            case metadata.Type === SharePointInputTypes.currency: {
                return InputTypeEnum.Currency;
            }
            case metadata.Format === SharePointFormatTypes.dateOnly: {
                return InputTypeEnum.DateOnly
            }
            case metadata.Format === SharePointFormatTypes.dateTime: {
                return InputTypeEnum.DateTime
            }
            case metadata.Type === SharePointInputTypes.note && +metadata.NumLines > 0: {
                return InputTypeEnum.MultiLine
            }
            case metadata.Type == SharePointInputTypes.taxonomyFieldType: {
                return InputTypeEnum.taxonomySingle
            }
            case metadata.Type === SharePointInputTypes.taxonomyFieldTypeMulti: {
                return InputTypeEnum.taxonomyDouble
            }
            case metadata.Type == SharePointInputTypes.Boolean: {
                return InputTypeEnum.YesNo
            }
            case metadata.Type === SharePointInputTypes.url && metadata.Format === SharePointFormatTypes.hyperlink: {
                return InputTypeEnum.hyperLink
            }
            case metadata.Type === SharePointInputTypes.url && metadata.Format === SharePointFormatTypes.image: {
                return InputTypeEnum.picture
            }
            case metadata.Type === SharePointInputTypes.choice && (metadata.Format === SharePointFormatTypes.dropdown || metadata.Format === SharePointFormatTypes.radioButtons): {
                return InputTypeEnum.choice
            }
            case metadata.Type === SharePointInputTypes.multiChoice: {
                return InputTypeEnum.multiChoice
            }
            case metadata.Type === SharePointInputTypes.user: {
                return InputTypeEnum.peoplePickerSingle
            }
            case metadata.Type === SharePointInputTypes.userMulti: {
                return InputTypeEnum.peoplePickerMultiple
            }
            case metadata.Type == SharePointInputTypes.lookupMulti: {
                return InputTypeEnum.lookupMulti
            }
            case metadata.Type == SharePointInputTypes.lookupSingle: {
                return InputTypeEnum.lookupSingle
            }
            default: {
                return InputTypeEnum.Text;
            }
        }
    }
}
